import React, { Component } from 'react';
import { Col, Row, Alert } from 'react-bootstrap/lib';
import { VehSingleDropDown, LoadingScreen, DateInput, DailyRide } from '../../generic/input';
import { parseMSIntoReadableTime } from '../../lib/dtconv';
import { MENUPATH, MOTION_SPEED_THRESH, HARDWARE_TYPES, MAPS_API_KEY, LITE_DRIVING_ALARMS } from '../../lib/enums';
import { GetDeviceAlarms } from '../../lib/db/rides';
const { computeStats, computeWirelessStats } = require('../../lib/geoDistCal');
const SPEED_THRESHOLD = 250;
const JAN_1_2019 = 1546281000000;

const { MapComponent, downloadRidesCSV } = require('../../lib/common');

export default class TimelineRideLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errMsg: "",
      title: "Vehicle Filter",
      showVehDrop: true,
      from: "",
      to: "",
      toEndTS: "",
      stats: "",
      center: { lat: 20.5837, lng: 78.9629 },
      isLoading: false
    }
    this.locEvts = [];
    this.mapMounted = false;
    this.isWireless = this.props.location.query.hwtyp == HARDWARE_TYPES.WIRELESS || this.props.location.query.hwtyp == HARDWARE_TYPES.AJJAS_LITE;
  }

  componentWillMount() {
    global.EE.addEventListener(global.EE.EVENT_TYPES.BIKES, this.onVehicles);
    global.EE.addEventListener(global.EE.EVENT_TYPES.LOCATION_EVENTS, this.onLocEvnts);
  }

  componentDidMount() {
    if (global.wsOnline) this.onVehicles(global.bikeDetails);
    global.EE.emitEvent(global.EE.EVENT_TYPES.MENU_CHANGE, MENUPATH.RIDE_LOG);
  }

  componentWillUnmount() {
    global.EE.removeEventListener(global.EE.EVENT_TYPES.BIKES, this.onVehicles);
    global.EE.removeEventListener(global.EE.EVENT_TYPES.LOCATION_EVENTS, this.onLocEvnts);
  }

  onLocEvnts = (pings) => {
    if (pings.obj.ts !== 0) {
      let ts = pings.obj.ts * 1000;
      if ((ts >= this.state.from) && (ts <= this.state.to)) this.locEvts.push(pings.obj);
    }
    else {
      if (this.tsArray && this.tsArray.length) {
        if (this.tsIndex !== this.lastTsIndex) {
          this.tsIndex += 1;
          if (this.tsArray && this.tsArray[this.tsIndex]) this.SendReqForPings(this.tsArray[this.tsIndex], (this.tsArray[this.tsIndex + 1] - 1000));
        } else this.computeStatistics();
      } else this.computeStatistics();
    }
  }

  computeStatistics() {
    if (this.locEvts.length) {
      this.locEvts.sort((a, b) => a.ts - b.ts);
      this.locEvts = this.locEvts.filter((p, i) => {
        if (p.isWireless) {
          let lastPing;
          if (p.lat && p.lng && p.spd !== undefined) {
            if(i > 0) lastPing = this.locEvts[i - 1];
            let isFluctuation = (p.spd === 0 && lastPing && lastPing.spd === 0);
            if (!isFluctuation) {
              return p;
            }
          }
        }
        else if (p.lat && p.lng && (p.ignition || (p.motion && p.spd > MOTION_SPEED_THRESH))) {
          return p;
        }
        return false;
      });
    }

    var stats, path = [];
    path = this.locEvts;
    if (this.isWireless) {
      stats = computeWirelessStats(path.sort((a, b) => a.ts - b.ts));
    } else {
      stats = computeStats(path.sort((a, b) => a.ts - b.ts));
    }
    if (stats && stats.dst && stats.dur) {
       stats.avs = ((stats.dst / stats.dur) * (18 / 5)) || 0;
    }
    this.showData({ path, stats });
  }

  showData = (details) => {
    if (details.path && details.path.length) {
      if (details.path) this.path = details.path;
      let centerIndex = this.path.length > 1 ? [Math.round(this.path.length / 2)] : 0;
      this.setState({
        stats: details.stats,
        isLoading: false,
        errMsg: "",
        center: { lat: this.path[centerIndex].lat, lng: this.path[centerIndex].lng }
      });
    }
    else this.setState({ isLoading: false, errMsg: "No Rides present between selected date range", stats: "" })
  }

  onVehicles = (vehicles) => {
    if (vehicles && vehicles.length) {
      vehicles = vehicles.filter(veh => { return veh.did; });
      this.vehicles = vehicles;
      if (this.props.location && this.props.location.query) {
        var loc = this.props.location;
        if (loc.query.vehId && loc.query.start && loc.query.end) {
          var fromDate = parseInt(loc.query.start, 10);
          var toDate = parseInt(loc.query.end, 10);
          var veh = vehicles.find(d => d.idx === parseInt(loc.query.vehId, 10));
          var endDate = new Date(parseInt(loc.query.start, 10) + (86400000 * 7)).setHours(23, 59, 59);
          if (endDate > Date.now()) endDate = Date.now();
          if (veh && toDate >= fromDate && toDate <= endDate) {
            this.selVeh = veh;
            this.setState({
              title: (veh.vmk ? veh.vmk : "") + " " + (veh.mo ? veh.mo : "") + " " + (veh.reg ? veh.reg : veh.treg),
              from: fromDate,
              toEndTS: endDate,
              to: toDate
            }, () => {
              this.getData();
            });
          }
        }
      }
      this.forceUpdate();
    }
    else this.setState({ errMsg: "This feature is only available for Plus device users. Add a vehicle with Plus HW." })
  }

  onClickVehicle = (veh) => {
    this.isWireless = false;
    if(veh.hwtyp === HARDWARE_TYPES.WIRELESS || veh.hwtyp === HARDWARE_TYPES.AJJAS_LITE) this.isWireless = true;
    var selectedTitle = (veh.vmk ? veh.vmk : "") + " " + (veh.mo ? veh.mo : "") + " " + (veh.reg ? veh.reg : veh.treg);
    if (selectedTitle) {
      this.setState({ showVehDrop: false, from: "", to: "", stats: "" }, () => {
        this.selVeh = veh;
        this.setState({ title: selectedTitle, showVehDrop: true });
      });
    }
  }

  onChangeFromDt = (e, StartDate) => {
    this.setState({ from: "" }, () => {
      let endDate = e[0].getTime() + (86400000 * 7);
      if (endDate > Date.now()) endDate = Date.now();
      this.setState({ from: e[0].getTime(), toEndTS: endDate, errMsg: "" });
    })
  }

  onChangeTo = (e) => {
    this.setState({ to: e[0].getTime(), errMsg: "" });
  }

  getStartTsArr(start, end) {
    var arr = [], dt = new Date(start), endDate = new Date(end);
    while (dt <= endDate) {
      arr.push(dt.getTime());
      dt.setDate(dt.getDate() + 1);
    }
    if (arr && arr.length && arr[arr.length - 1] < end) arr.push(end);
    return arr;
  }

  processRidingBehaviour = (alarms) => {
    const counts = {};
    alarms.forEach(alm => {
      if (Object.values(LITE_DRIVING_ALARMS).includes(alm.alarmTyp)) {
        counts[alm.alarmTyp] = (counts[alm.alarmTyp] || 0) + 1;
      }
    });

    this.setState({ rideBehaviours: counts });
  };

  getData = () => {
    if (this.state.from > this.state.to) this.setState({ errMsg: "Start time can't be greater than end time" });
    else {
      var tsDiff = (this.state.to - this.state.from) / 3600000;
      this.path = [];
      this.locEvts = [];
      this.mapMounted = false;
      this.setState({ isLoading: true, rideBehaviours: [] });
      global.EE.emitEvent(global.EE.EVENT_TYPES.REMOVE_LOC_LISTENER, true);
      if (tsDiff > 24) {
        this.tsArray = this.getStartTsArr(this.state.from, this.state.to);
        this.tsIndex = 0;
        this.lastTsIndex = this.tsArray.length - 2;
        this.SendReqForPings(this.tsArray[this.tsIndex], (this.tsArray[this.tsIndex + 1] - 1000));
      } else {
        this.SendReqForPings(this.state.from, this.state.to);
      }

      if (this.selVeh.hwtyp === HARDWARE_TYPES.AJJAS_LITE) {
        GetDeviceAlarms({ vid: this.selVeh.idx, from: this.state.from, to: this.state.to }, (error, result) => {
          if (result) this.processRidingBehaviour(result);
        });
      }
    }

    var newUrl = this.props.location.pathname;
    newUrl += "?vehId=" + this.selVeh.idx + "&start=" + this.state.from + "&end=" + this.state.to;
    if (this.selVeh.hwtyp) newUrl += "&hwtyp=" + this.selVeh.hwtyp;
    this.props.router.replace(newUrl)
  }

  SendReqForPings = (fromTs, toTs) => {
    var data = { vid: this.selVeh.idx, fromTs: Math.round(fromTs / 1000), toTs: Math.round(toTs / 1000), isWeb: true };
    global.gWebSocket.SendRequest({ data: { a: "getLocEvents", d: data }});
  }

  handleMapMounted = (map) => {
    if (this.mapMounted) return;
    var bounds = new window.google.maps.LatLngBounds();
    this.path.forEach((path) => {
      bounds.extend(new window.google.maps.LatLng(path.lat, path.lng));
    })
    this._ref.fitBounds(bounds);
    this.mapMounted = true;
  }

  _onChange(latlng, zoom) {
    this.setState({
      zoom: zoom,
      center: this._ref.getCenter()
    })
  }

  mapDisplay() {
    var latlng = { lat: this.path[0].lat, lng: this.path[0].lng };
    return (
      <div className="margin-bottom15 map">
        <MapComponent
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${MAPS_API_KEY}&v=3.exp&libraries=drawing,places`}
          loadingElement={<div style={{ height: '100%' }} />}
          containerElement={<div style={{ height: '50vh' }} />}
          mapElement={<div style={{ height: '100%' }} />}
          center={this.state.center}
          zoom={this.state.zoom}
          onZoomChanged={() => this._onChange(latlng, this.state.zoom)}
          trafficCheck={this.state.trafficCheck}
          pathTrail={this.path}
          regionA={latlng}
          regionB={{ lat: this.path[this.path.length - 1].lat, lng: this.path[this.path.length - 1].lng }}
          onMapIdle={this.handleMapMounted}
          referance={(ref) => this._ref = ref}
        />
      </div>
    )
  }

  showStats = (ride) => {
    var start = new Date(this.state.from).toString().split('GMT')[0];
    var end = new Date(this.state.to).toString().split('GMT')[0];
    var style = "col-lg-2 col-md-4 col-sm-4 col-xs-4 margin-bottom20px";
    const behaviours = this.state.rideBehaviours;
    return (
      <div className="col-sm-12 col-xs-12">
        <div className="font-size16px font-bold" style={{ marginTop: "1%", marginBottom: "1%" }}>{start + " -- " + end}</div>
        <div >
          {DailyRide("Distance", ride.dst ? ((ride.dst) / 1000).toFixed(1) + " km" : "-", "", style)}
          {DailyRide("Avg Speed", ride.avs ? ride.avs < SPEED_THRESHOLD ? ride.avs.toFixed(2) + " km/h" : SPEED_THRESHOLD + " km/h" : "-", "", style)}
          {DailyRide("Top Speed", ride.tps ? ride.tps < SPEED_THRESHOLD ? ride.tps.toFixed(2) + " km/h" : SPEED_THRESHOLD + " km/h" : "-", "", style)}
          {!this.isWireless ? DailyRide("Max Lean Angle", ride.mang ? ride.mang.toFixed(2) + "°" : "-", "", style): ""}
          {this.props.location.query && this.props.location.query.hwtyp != HARDWARE_TYPES.WIRELESS ? DailyRide("Duration", ride.dur ? parseMSIntoReadableTime(ride.dur * 1000) : "-", null, style): ""}
          {DailyRide("Running Time", ride.runningTime ? parseMSIntoReadableTime(ride.runningTime * 1000) : "-", null, style)}
          {DailyRide("Start", ride.sdt ? new Date(ride.sdt * 1000).toString().split('GMT')[0] : "", "", style)}
          {DailyRide("End", ride.edt ? new Date(ride.edt * 1000).toString().split('GMT')[0] : "-", "", style)}
          {behaviours && DailyRide("Harsh Accelerations", behaviours[LITE_DRIVING_ALARMS.HARSH_ACCEL] || 0, "", style)}
          {behaviours && DailyRide("Harsh Brakings", behaviours[LITE_DRIVING_ALARMS.SUDDEN_BRAKE] || 0, "", style)}
          {behaviours && DailyRide("Harsh Cornerings", behaviours[LITE_DRIVING_ALARMS.SHARP_TURN] || 0, "", style)}
        </div>
      </div>
    )
  }

  downloadCSV = () => {
    downloadRidesCSV(this.locEvts, "ride_log_" + Date.now(), "ajjas_", this.props.location.query.hwtyp);
  }

  render() {
    return (
      this.vehicles && this.vehicles.length > 0 && this.state.showVehDrop ?
        <Col>
          <Row>
            <Col lg={4} md={4} sm={6} xs={12} style={{ marginTop: "0%", marginBottom: "-2px" }}>
              <p className="color-e1e1e1 font-size12px color-b5b5b5">Select Vehicle</p>
              <VehSingleDropDown vehicles={this.vehicles} onClick={(e) => this.onClickVehicle(e)} title={this.state.title} />
            </Col>
            <Col lg={3} md={4} sm={6} xs={12} >
              <p className="color-e1e1e1 font-size12px color-b5b5b5">Time From: </p>
              <DateInput defaultdate={this.state.from ? this.state.from : ""} enableTime={true} dateFormat={true} mindate={JAN_1_2019} maxdate={Date.now()} onChange={(e) => this.onChangeFromDt(e)}></DateInput>
            </Col>
            {this.state.from ?
              <Col lg={3} md={4} sm={6} xs={12} >
                <p className="color-e1e1e1 font-size12px color-b5b5b5">Time To: </p>
                <DateInput defaultdate={this.state.to ? this.state.to : ""}  enableTime={true} dateFormat={true} mindate={this.state.from} maxdate={this.state.toEndTS} onChange={(e) => this.onChangeTo(e)}></DateInput>
              </Col>
              : null
            }
          </Row>
          <Row className="margin-top2">
            {
              this.selVeh && this.state.from && this.state.to ?
                <Col lg={1} md={2} sm={4} xs={4} style={{ marginTop: "0%" }}>
                  <input type="button" className="btn btn-primary" value="Search" onClick={this.getData} />
                </Col>
                : null
            }
            {
              this.path && this.path.length && global.userId ?
                <Col lg={1} md={2} sm={4} xs={4} style={{ marginTop: "0%" }}>
                  <input type="button" className="btn btn-primary" value="Download" onClick={this.downloadCSV} />
                </Col>
                : null
            }
          </Row>
          <Row className="margin-top2">
            {this.state.errMsg ?
              <Col lg={10} md={9} sm={12} xs={12}><Alert style={{ paddingLeft: "10px" }} bsStyle="danger">{this.state.errMsg}</Alert></Col>
              : ""}
          </Row>
          {this.state.isLoading ? <LoadingScreen /> : null}
          {
            this.state.stats ?
              <Col lg={12} md={12} sm={12} xs={12} className="border-gray" style={{ paddingLeft: "0%", paddingBottom: "15px", marginTop: "1%" }}>
                {this.showStats(this.state.stats)}
                {this.path.length > 0 ?
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ paddingRight: "0px" }} >{this.mapDisplay()}</div> : null
                }
              </Col>
              : null
          }
        </Col>
        : <Col lg={10} md={9} sm={12} xs={12}>
          <Alert bsStyle="warning"> Ajjas device is not installed</Alert>
        </Col>
    )
  }
}